import User from './User';

/**
 * User Detail Page - Wrapper for React Router
 */
function UserPage() {
	return <User />;
}

export default UserPage;
